import { createContext } from 'react'

export const FloatingPanelContext = createContext<{
  isEnabled: boolean
  isShown: boolean
  show: () => void
  hide: () => void
}>({
  isEnabled: false,
  isShown: false,
  show: () => null,
  hide: () => null
})
